import Header from "../../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button } from "@mui/material"

import BackIcon from "../../../../components/BackIcon"
import { useState, forwardRef, useEffect, useImperativeHandle, useRef } from "react"
import { useMutation } from "@tanstack/react-query"
import fetchwrapper from "../../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../../components/CustomBackdrop"
import CustomTextFieldReadable from "../../../../components/CustomTextFieldReadable"
import CustomTextField from "../../../../components/CustomTextField"
import { useLocation, useNavigate } from "react-router-dom"
import normalFormatDate from "../../../utils/date/DDMMYYYFormatDate"
import GrabarIcon from "../../../../assets/iconos/Grabar.ico"
import CustomTooltip from "../../../../components/ToolTip"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
// ************************************************************
//                 CABECERA CITA COMPONENTE
// ************************************************************
const ContainerFormCounter = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
          "IPedidoID IPedidoID IPedidoID IPedidoID IPedidoID IPedidoID IVendedor IVendedor IVendedor IVendedor IVendedor IVendedor"
          "IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaInicial IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal IFechaFinal"
          "ICliente ICliente ICliente ICliente ICliente ICliente ICliente ICliente ICliente ICliente ICliente ICliente"
          "IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario"
        `,
  gap: "8px",
  alignItems: "center",
}))

const IPedidoIDCounter = styled(Box)({
  gridArea: "IPedidoID",
})
const IVendedorCounter = styled(Box)({
  gridArea: "IVendedor",
})
const IFechaInicialCounter = styled(Box)({
  gridArea: "IFechaInicial",
})
const IFechaFinalCounter = styled(Box)({
  gridArea: "IFechaFinal",
})
const IClienteCounter = styled(Box)({
  gridArea: "ICliente",
})
const IComentarioCounter = styled(Box)({
  gridArea: "IComentario",
})

const PantallaCita = forwardRef(({ dataInfo }, ref) => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    pednumped: "",
    vendedor: null,
    vennombre: "",
    vencodigo: "",
    pedfecemi: "",
    pedfecven: "",
    nickname: "",
    comentario: "",
  })
  const handleSetFormData = (k, v) => setFormData((prev) => ({ ...prev, [k]: v }))

  useEffect(() => {
    if (dataInfo) {
      setFormData((prev) => ({
        ...dataInfo,
      }))
    }
  }, [dataInfo])

  const { mutateAsync: editPedido, isPending: isEditingPedido } = useEditPedido()

  function useEditPedido() {
    return useMutation({
      mutationFn: async (data) => {
        const options = {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }

        let response = await fetchwrapper(`/AdministradorPedidosMostrador/editCabeceraCita`, options)

        response = response.json()
        return response
      },
      onError: () => {
        alert("No se pudo hacer el pedido. Intente otra vez")
      },
      onSuccess: () => {
        alert("Pedido editado con éxito")
      },
    })
  }

  const handleEditing = async () => {
    if (!formData.nickname || formData.nickname === "") {
      return alert("Digite un nombre")
    }

    await editPedido({
      pednumped: formData.pednumped,
      nickname: formData.nickname.trim(),
      comentario: formData.comentario.trim(),
    })
    navigate(-1)
  }

  // Expone la función al padre
  useImperativeHandle(ref, () => ({
    edit: handleEditing,
  }))

  return (
    <>
      <CustomBackdrop isLoading={isEditingPedido} />
      <ContainerFormCounter>
        <IPedidoIDCounter>
          <CustomTextFieldReadable
            label="Pedido ID"
            value={formData.pednumped}
            sxInput={{
              backgroundColor: "#E0CB79",
            }}
          ></CustomTextFieldReadable>
        </IPedidoIDCounter>
        <IVendedorCounter>
          <CustomTextFieldReadable label="Vendedor" value={formData.vennombre} />
        </IVendedorCounter>
        <IFechaInicialCounter>
          <CustomTextFieldReadable label="Fecha Emisión" value={normalFormatDate(formData.pedfecemi)} />
        </IFechaInicialCounter>
        <IFechaFinalCounter>
          <CustomTextFieldReadable label="Fecha Vencimiento" value={normalFormatDate(formData.pedfecven)} />
        </IFechaFinalCounter>

        <IClienteCounter>
          <CustomTextField
            label="Nickname"
            value={formData.nickname}
            setValue={(v) => handleSetFormData("nickname", v)}
          ></CustomTextField>
        </IClienteCounter>

        <IComentarioCounter>
          <CustomTextField
            label="Comentario"
            value={formData.comentario}
            setValue={(v) => handleSetFormData("comentario", v)}
          />
        </IComentarioCounter>
      </ContainerFormCounter>
    </>
  )
})

const AdministradorPedidosMostradorActualizarCita = () => {
  const pantallaCitaRef = useRef(null)
  const location = useLocation()
  const dataCita = location.state

  const handleEditCita = () => {
    pantallaCitaRef.current?.edit()
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>CITA</b>
        </div>

        <Box className={StyledRoot}>
          <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "5px" }}>
              <CustomTooltip title={"Grabar"}>
                <Button onClick={handleEditCita}>
                  <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
                </Button>
              </CustomTooltip>
            </div>
          </div>
          <br />
          <br />
          <PantallaCita ref={pantallaCitaRef} dataInfo={dataCita} />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default AdministradorPedidosMostradorActualizarCita
